import React, { useEffect, useState } from "react";
import { getDay } from "../../../services/formateDate";

const ConcertCard = ({ setIsVisible, slide }) => {
  const handleNavigate = () => {};

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to update the screen width
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Set initial state and add listener
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getTruncatedCity = () => {
    if (!slide?.city) return "Bangalore"; // Default value

    if (screenWidth < 480) {
      return slide.city;
    } else if (screenWidth >= 480 && screenWidth < 630) {
      return slide.city.length > 10
        ? `${slide.city.substring(0, 10)}...`
        : slide.city;
    } else if (screenWidth >= 630 && screenWidth < 750) {
      return slide.city.length > 12
        ? `${slide.city.substring(0, 12)}...`
        : slide.city;
    } else if (screenWidth >= 750 && screenWidth < 990) {
      return slide.city.length > 10
        ? `${slide.city.substring(0, 10)}...`
        : slide.city;
    } else if (screenWidth >= 991 && screenWidth < 1500) {
      return slide.city.length > 8
        ? `${slide.city.substring(0, 8)}...`
        : slide.city;
    } else if (screenWidth >= 1501 && screenWidth < 2500) {
      return slide.city.length > 13
        ? `${slide.city.substring(0, 13)}...`
        : slide.city;
    } else {
      return slide.city;
    }
  };

  const getDynamicClass = () => {
    if (screenWidth < 480) {
      return "hidden"; // Hidden for small screens
    } else if (screenWidth >= 480 && screenWidth < 630) {
      return "inline"; // Visible for medium-small screens
    } else if (screenWidth >= 630 && screenWidth < 750) {
      return "inline"; // Visible for medium screens
    } else if (screenWidth >= 750 && screenWidth < 1500) {
      return "hidden"; // Visible for larger screens
    } else {
      return "inline"; // Visible for extra-large screens
    }
  };

  function formatDate(dateString) {
    if (!dateString) return "";
    const [day, month, year] = dateString.split(" ")[0].split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
    });
  }

  function formatTime(dateString) {
    if (!dateString) return "";
    const [day, month, year, time] = [
      ...dateString.split(" ")[0].split("-"),
      dateString.split(" ")[1],
    ];
    const date = new Date(`${year}-${month}-${day}T${time}`);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  const eventTimeClass = getDynamicClass(screenWidth);

  return (
    <div
      id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fae-3890e283"
      className="table-list-card"
    >
      <div className="text-5xl text-black"></div>
      <div className="property-image custom-bg _2">
        <div className="table-card-div">
          <div className="property-image-inner">
            <div className="p-image-inner-info-top">
              <div className="card-image-left-meta">
                <p className="category">{slide?.category?.name}</p>
              </div>
              <div className="card-image-left-meta">
                {slide?.bookmarks > 0 && (
                  <div className="text-block">{slide?.bookmarks}</div>
                )}

                {/* {bookmarks.includes(slide.id) ? ( */}
                <a
                  className="
                   wishlist-iconf"
                  // onClick={handleBookmark}
                >
                  <div className="w-embed trnasparentbg" aria-disabled>
                    <svg
                      width={25}
                      height={31}
                      viewBox="0 0 25 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_106_21)">
                        <path
                          d="M2.09347 30.4104L1.28265 3.1953L3.89584 1.39294L22.6035 2.02352L24.3525 5.80846L23.9016 29.3165L22.0993 30.4104L12.5297 23.2908L2.09347 30.4104Z"
                          fill="currentColor"
                        />
                        <path
                          d="M0.0016976 16.1519C0.0016976 12.1548 -0.00129803 8.15762 0.0016976 4.16049C0.00619104 2.40806 0.859945 1.09549 2.65283 0.365059C3.2175 0.133399 3.89152 0.0225612 4.51511 0.0200649C9.83284 -0.00589703 15.1506 -0.00290143 20.4668 0.00908098C23.0336 0.0145729 24.9213 1.68312 24.9867 3.97925C25.0122 4.85747 24.9942 5.73568 24.9942 6.61389V28.2651C24.9942 29.4898 24.3566 30.4204 23.2133 30.8064C22.1294 31.1718 21.1343 30.9971 20.2591 30.3126C17.8501 28.4304 15.4427 26.5466 13.0352 24.6634C12.5129 24.2545 12.487 24.2545 11.9737 24.6554C9.56623 26.5391 7.15725 28.4224 4.74827 30.3031C3.82462 31.0246 2.77665 31.2068 1.66227 30.7525C0.549897 30.2986 0.00469323 29.4733 0.00469323 28.3784C0.0016976 24.3029 0.00469323 20.2274 0.00469323 16.1519H0.0016976ZM2.42566 16.103C2.42566 20.1435 2.42266 24.1851 2.43614 28.2257C2.43614 28.4124 2.52701 28.668 2.67679 28.7709C2.90696 28.9266 3.10816 28.7085 3.2884 28.5692C5.69588 26.6869 8.10487 24.8047 10.5109 22.9215C11.7675 21.9379 13.2334 21.9404 14.496 22.9284C16.9125 24.8187 19.3275 26.7119 21.7534 28.5911C21.9002 28.705 22.1728 28.7993 22.3351 28.7549C22.4579 28.7209 22.5623 28.4478 22.5623 28.2811C22.5727 20.2219 22.5742 12.1627 22.5697 4.10207C22.5697 2.90733 21.728 2.16991 20.3909 2.16991C15.1246 2.16841 9.8598 2.16841 4.59349 2.17141C4.36932 2.17141 4.13616 2.18239 3.92098 2.23382C2.96687 2.46098 2.42666 3.17144 2.42516 4.18096C2.42366 8.15513 2.42516 12.1278 2.42516 16.102V16.1035L2.42566 16.103Z"
                          fill="white"
                        />
                        <path
                          d="M12.8173 9.71127L12.4998 10.0168C12.5826 10.1032 12.6975 10.1516 12.8173 10.1516C12.9371 10.1516 13.0514 10.1027 13.1348 10.0168L12.8173 9.71127ZM11.306 17.2387C10.4163 16.5373 9.44322 15.8523 8.67084 14.983C7.91395 14.1308 7.38622 13.1362 7.38622 11.8461H6.5055C6.5055 13.4113 7.15755 14.6051 8.0123 15.5677C8.85208 16.5133 9.92301 17.2702 10.7603 17.9302L11.3055 17.2387H11.306ZM7.38622 11.8461C7.38622 10.5835 8.09968 9.52405 9.07376 9.0792C10.0199 8.64684 11.2915 8.76117 12.4998 10.0168L13.1343 9.40622C11.7004 7.91691 10.0363 7.67127 8.70729 8.27838C7.40619 8.873 6.505 10.254 6.505 11.8466H7.38572L7.38622 11.8461ZM10.7608 17.9307C11.0614 18.1679 11.3844 18.4205 11.7114 18.6117C12.0384 18.8029 12.4119 18.9582 12.8173 18.9582V18.0775C12.6356 18.0775 12.4219 18.0066 12.1558 17.8513C11.8901 17.6961 11.6145 17.4824 11.306 17.2392L10.7608 17.9307ZM14.8738 17.9307C15.7116 17.2702 16.782 16.5138 17.6218 15.5682C18.4765 14.6056 19.1286 13.4113 19.1286 11.8466H18.2479C18.2479 13.1367 17.7201 14.1313 16.9632 14.9835C16.1914 15.8528 15.2183 16.5378 14.3286 17.2392L14.8738 17.9307ZM19.1291 11.8461C19.1291 10.254 18.2279 8.873 16.9268 8.27788C15.5977 7.67027 13.9337 7.91591 12.5003 9.40572L13.1348 10.0163C14.3431 8.76117 15.6147 8.64634 16.5608 9.0787C17.5349 9.52405 18.2484 10.583 18.2484 11.8456H19.1291V11.8461ZM14.3286 17.2387C14.0195 17.4824 13.7444 17.6961 13.4788 17.8508C13.2132 18.0061 12.999 18.077 12.8173 18.077V18.9577C13.2227 18.9577 13.5957 18.8024 13.9232 18.6112C14.2502 18.42 14.5732 18.1674 14.8738 17.9302L14.3286 17.2387Z"
                          fill="white"
                        />
                        <path
                          d="M13.3165 19.4575H12.318V19.399C12.0409 19.3346 11.7568 19.2163 11.4598 19.0431C11.2486 18.9197 11.0399 18.7735 10.8466 18.6287L10.8442 18.6322L10.4522 18.3231C10.4522 18.3231 10.4517 18.3226 10.4512 18.3221L10.4497 18.3206C10.2979 18.2008 10.1392 18.079 9.97143 17.9497C9.21403 17.3665 8.35578 16.706 7.63983 15.8997C6.66525 14.8023 6.13503 13.6355 6.02718 12.3459H6.00671V11.3474H6.03367C6.19993 9.80063 7.13157 8.45061 8.50107 7.82453C9.91101 7.17998 11.4752 7.42012 12.8183 8.45211C14.1613 7.42012 15.7255 7.17998 17.1355 7.82453C18.505 8.45061 19.4366 9.80063 19.6029 11.3474H19.6298V12.3459H19.6094C19.502 13.6355 18.9713 14.8023 17.9967 15.8997C17.2808 16.7055 16.423 17.3665 15.6656 17.9497C15.5009 18.0765 15.3451 18.1963 15.1958 18.3141L15.1843 18.3231C15.1843 18.3231 15.1823 18.3246 15.1818 18.3251L14.7924 18.6322L14.7894 18.6287C14.5957 18.774 14.387 18.9197 14.1763 19.0431C13.8792 19.2163 13.5951 19.3346 13.318 19.399V19.4575H13.3165ZM12.8173 17.5782C12.8692 17.5782 12.9915 17.5577 13.2267 17.4204C13.4608 17.2836 13.7135 17.0884 14.0195 16.8473L14.4114 16.5382L14.4134 16.5407C14.4569 16.5073 14.5003 16.4738 14.5437 16.4404C15.2587 15.8892 15.9976 15.3195 16.5903 14.652C17.3811 13.7618 17.7491 12.8701 17.7491 11.8466C17.7491 10.8231 17.2014 9.92145 16.3531 9.53352C15.4444 9.11813 14.4035 9.41969 13.4963 10.3608L13.4943 10.3633C13.4943 10.3633 13.4943 10.3633 13.4938 10.3638L13.1483 10.7228L13.0444 10.6229C12.8967 10.6599 12.7379 10.6599 12.5901 10.6229L12.4863 10.7228L12.1403 10.3633L12.1393 10.3623C11.2321 9.42019 10.1906 9.11813 9.28143 9.53352C8.43367 9.92095 7.88547 10.8291 7.88547 11.8466C7.88547 12.8641 8.25393 13.7618 9.04428 14.652C9.63691 15.319 10.3763 15.8892 11.0913 16.4404C11.1342 16.4733 11.1777 16.5068 11.2211 16.5407L11.2231 16.5382L11.607 16.8408C11.6095 16.8428 11.6125 16.8453 11.615 16.8473L11.631 16.8598C11.9296 17.0949 12.1772 17.2856 12.4079 17.4204C12.643 17.5577 12.7653 17.5782 12.8173 17.5782Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_106_21">
                          <rect width={25} height={31} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div
            id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbb-3890e283"
            onClick={handleNavigate}
            className="table-card-image w-inline-block relative "
          >
            <div className="absolute bottom-2 right-2">
              <div className="">
                <p className="price_category shadow-xl">
                  <div className="text-sm flex items-center text-gray-50">
                    {" "}
                    <div className="text-base font-medium">₹{slide?.price}</div>
                    <div className="text-xs">&nbsp;/ seat</div>
                  </div>
                </p>
              </div>
            </div>
            <img
              loading="lazy"
              src={`https://high-table-2024.s3.ap-south-1.amazonaws.com/public/photo/tables/hd/${slide?.media}`}
              alt=""
              className="table-image-oncard placeholderimg"
            />
            <div className="card-overlay-grad" />
          </div>
        </div>
      </div>
      <div
        id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbd-3890e283"
        onClick={handleNavigate}
        className="card-details w-inline-block"
      >
        <div className="card-meta-datat">
          <div
            id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbf-3890e283"
            className="location-div"
          >
            <div className="code-embed-4 location-icon-oncard w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="card-location feature-label max-h-12 overflow-hidden truncate">
              <span className="event-date">
                {getDay(slide?.event_date)?.slice(0, 3)},{" "}
                {formatDate(slide?.event_date)}
              </span>
              <span className={`event-time ${eventTimeClass}`}>
                , {formatTime(slide?.event_date)}
              </span>
            </div>
          </div>
          <div className="date-on-card">
            <div className="code-embed-4 date-icon-on-card w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="card-location feature-label  overflow-hidden truncate">
              {getTruncatedCity()}
            </div>
          </div>
        </div>
        <div className="card-title clamptitle">{slide?.title}</div>

        <div className="card-meta-datat comapny-and-date">
          <div className="property-size property-company">
            <div className="host-dp">
              <img
                loading="lazy"
                src={
                  slide?.user_profile?.photo
                    ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${slide?.user_profile?.photo}`
                    : "https://as2.ftcdn.net/v2/jpg/03/31/69/91/1000_F_331699188_lRpvqxO5QRtwOM05gR50ImaaJgBx68vi.jpg"
                }
                alt=""
                className="host-image-on-card"
              />
            </div>
            <p className="host-name darkgrey">
              {" "}
              {slide.user_profile?.first_name}
              &nbsp;
              {slide.user_profile?.last_name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConcertCard;
